import { render, staticRenderFns } from "./productManual.vue?vue&type=template&id=685734ee&scoped=true"
import script from "./productManual.vue?vue&type=script&lang=js"
export * from "./productManual.vue?vue&type=script&lang=js"
import style0 from "./productManual.vue?vue&type=style&index=0&id=685734ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685734ee",
  null
  
)

export default component.exports